import React, { useState, useEffect, useCallback } from 'react';
import { Table, Button, Row, Col, Divider, message, Tabs } from 'antd';
import moment from  'moment';
import isEmpty from 'lodash/isEmpty';
import values from 'lodash/values';
import isNaN from 'lodash/isNaN';
import Widget from 'components/Widget';
import { connect } from 'react-redux';
import { fetchCategory } from 'appRedux/actions/Category';
import { fetchFreq } from 'appRedux/actions/Freq';
import { fetchBuzz } from 'appRedux/actions/Buzz';
import { fetchCampaign } from 'appRedux/actions/Campaign';
import { fetchRateCard } from 'appRedux/actions/RateCard';
import { fetchRateCardValue } from 'appRedux/actions/RateCardValue';
import { fetchSampleSize, resetSampleSize, fetchMultiSampleSize, updateSampleSize } from 'appRedux/actions/SampleSize';
import { fetchPeopleLevelInBrand } from 'appRedux/actions/PeopleLevelInBrand';
import { fetchPeopleLevelInCampaign } from 'appRedux/actions/PeopleLevelInCampaign';
import { addQuota, resetAddQuota } from 'appRedux/actions/Quota';
import { addCrisis, resetAddCrisis } from 'appRedux/actions/Crisis';
import convertData from 'firebase/utils/convertData';
import FormInput from './FormInput';
import CalculatedCrisis from './CalculatedCrisis';
import BuzzColumns from './BuzzColumns';
import BrandColumns from './BrandColumns';
import IncludingBrandColumns from './IncludingBrandColumns';
import Columns from './Columns';
import { EditableCellBrand, EditableFormRowBrand } from './EditableCellBrand';
import { EditableCellCampaign, EditableFormRowCampaign } from './EditableCellCampaign';
import { EditableCell, EditableFormRow } from './EditableCell';
import { INIT_DATA_SOURCE, INIT_DATA_BRAND, INIT_DATA_COMP } from './constants';
import computeData, { computeTimeConstraint } from 'util/computeData';
import getKeyFromDataComp from 'util/getKeyFromDataComp';
import mergeDataComp from 'util/mergeDataComp';
import getOldDataComp from 'util/getOldDataComp';
import getMonthVolumeFromBrand from 'util/getMonthVolumeFromBrand';
import computeDailypriceForCrisis from 'util/computeDailypriceForCrisis';
import {
  // computeDataCompWithSpam,
  convertToSpamVolume,
} from 'util/computeDataCompWithSpam';

const { TabPane } = Tabs;

const InsertQuota = ({
  fetchCategory,
  fetchFreq,
  fetchCampaign,
  updateSampleSize,
  fetchSampleSize,
  fetchMultiSampleSize,
  fetchPeopleLevelInCampaign,
  fetchPeopleLevelInBrand,
  loadingFreq,
  buzzList,
  campaignList,
  currentUser,
  categoryList,
  freqList,
  rateCardList,
  rateCardValueList,
  sampleList,
  peopleLevelInBrandList,
  peopleLevelInCampaignList,
  loadingCategory,
  loadingBuzz,
  loadingCampaign,
  loadingSample,
  loadingSampleMulti,
  fetchBuzz,
  fetchRateCard,
  fetchRateCardValue,
  addQuota,
  addCrisis,
  resetAddCrisis,
  resetAddQuota,
  resetSampleSize,
  updating,
  updatingCrisis,
  payload,
  payloadCrisis
}) => {
  const [dataComp, setDataComp] = useState(INIT_DATA_COMP);
  const [dataSource, setDataSource] = useState(INIT_DATA_SOURCE);
  const [chosenBrand, setChosenBrand] = useState(-1);
  const [currentTab, setCurrentTab] = useState('brand');
  const [fields, setFields] = useState({ project: '', category: '', data_freq: 'Monthly' });
  const [totalTime, setTotalTime] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [isReset, setIsReset] = useState(false);
  const [isResetDataComp, setIsResetDataComp] = useState(false);
  const [priceForCrisis, setPriceForCrisis] = useState({});
  const [toggleBSIMsg, setToggleBSIMsg] = useState(false);

  const freq = isEmpty(freqList) ? [] : convertData(freqList);
  const categories = isEmpty(categoryList) ? [] : convertData(categoryList);
  const brands = isEmpty(buzzList) ? [] : convertData(buzzList);
  const campaigns = isEmpty(campaignList) ? [] : convertData(campaignList);
  const rateCards = isEmpty(rateCardList) ? [] : convertData(rateCardList);
  const rateCardValues = isEmpty(rateCardValueList) ? [] : convertData(rateCardValueList);
  const peopleLevelInBrands = isEmpty(peopleLevelInBrandList) ? [] : convertData(peopleLevelInBrandList);
  const peopleLevelInCampaigns = isEmpty(peopleLevelInBrandList) ? [] : convertData(peopleLevelInCampaignList);
  const peopleLevelList = currentTab === 'brand' ? peopleLevelInBrands : peopleLevelInCampaigns;

  const categoryNameChosen = fields.category ? fields.category.split('_')[0] : '';
  const spamOfCategory = fields.category ? fields.category.split('_')[4] : '';
  const savingPercentOfCategory = fields.category ? fields.category.split('_')[6] : 1;
  const isDisabledSubmit = !fields.project || !fields.category;
  const isEmptyComp = values(dataComp[0]).every(item => item.prev === 0);
  const isEmptySampleList = sampleList.every(item => item * 1 === 0);
  const monthVolume = fields.brand ? getMonthVolumeFromBrand(fields.brand) : { name: '', volume: 0 };

  const components = {
    body: {
      row: EditableFormRow,
      cell: EditableCell,
    },
  };

  const columns = Columns(isReset || isEmptyComp).map(col => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: record => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
        handleShowBSIMsg,
        handleFetchSampleSize: handleFetchSampleSize,
        loadingFreq: loadingFreq,
        freq: freq,
        isReset,
        isEmptyComp,
        maxFrequency: fields.data_freq,
        dataComp,
      }),
    };
  });

  const componentsBrand = {
    body: {
      row: EditableFormRowBrand,
      cell: EditableCellBrand,
    },
  };

  const componentsCampaign = {
    body: {
      row: EditableFormRowCampaign,
      cell: EditableCellCampaign,
    },
  };

  const columnsBrand = BrandColumns().map(col => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: record => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: handleSaveComp,
        brands,
        loadingBuzz,
        isReset,
        isResetDataComp,
        spamOfCategory,
        categoryNameChosen,
      }),
    };
  });

  const columnsCampaign = BrandColumns().map(col => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: record => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: handleSaveComp,
        brands: campaigns,
        loadingBuzz: loadingCampaign,
        isReset,
        isResetDataComp,
        spamOfCategory,
        categoryNameChosen,
      }),
    };
  });

  const reset = useCallback(() => {
    setIsReset(true);
    setDataComp(INIT_DATA_COMP);
    setDataSource(INIT_DATA_SOURCE);
    setFields({ project: '', category: '', data_freq: 'Monthly' });
    setTotalTime(0);
    setTotalPrice(0);
    setChosenBrand(-1);
    setPriceForCrisis({});
    setIsResetDataComp(true);
    setToggleBSIMsg(false);
    resetSampleSize();
  }, [resetSampleSize])

  const handleSave = row => {
    const newData = [...dataSource];
    const index = newData.findIndex(item => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    const oldDataComp = getOldDataComp(dataComp);
    const mergedDataComp = mergeDataComp(dataComp, sampleList);
    const sampleRow = newData[0];
    const params = Object.keys(sampleRow).reduce((res, key) => {
      if (key.includes('brand')) {
        return [...res, sampleRow[key]];
      }
      return res;
    }, []);
    updateSampleSize(params);
    const computedData = computeData(newData, fields, rateCards, mergedDataComp, freq, peopleLevelList, oldDataComp, spamOfCategory);
    setDataSource(computedData.convertedNewData);
    setTotalTime(computedData.totalHour);
    setTotalPrice(computedData.totalPrice);
    setIsReset(false);
    setIsResetDataComp(false);
  };

  const handleShowBSIMsg = (toggle) => {
    setToggleBSIMsg(toggle);
  };

  const handleSaveComp = data => {
    const newDataComp = [{
      ...dataComp[0],
      ...data,
    }];
    handleFetchSampleSizeFromChangingBrand(data);
    const newData = [...dataSource];
    const oldDataComp = getOldDataComp(newDataComp);
    const mergedDataComp = mergeDataComp(newDataComp, sampleList);
    const computedData = computeData(newData, fields, rateCards, mergedDataComp, freq, peopleLevelList, oldDataComp, spamOfCategory);
    setDataComp(newDataComp);
    setDataSource(computedData.convertedNewData);
    setTotalTime(computedData.totalHour);
    setTotalPrice(computedData.totalPrice);
    setIsReset(false);
    setIsResetDataComp(false);
  };

  const handleChangeFormFields = (inputFields) => {
    const newFields = {...fields, ...inputFields};
    const name = newFields.category ? newFields.category.split('_')[0] : '';
    const spam = newFields.category ? newFields.category.split('_')[4] * 1 : 0;
    if (currentTab === 'crisis') {
      if (newFields.category || newFields.brand || newFields.data_freq) {
        const monthBuzz = newFields.brand ? getMonthVolumeFromBrand(newFields.brand) : { name: '', volume: 0 };
        const partTime = rateCardValues.find(value => value.department === 'Data & Crisis' && value.position === 'Part-time');
        const fullTime = rateCardValues.find(value => value.department === 'Data & Crisis' && value.position === 'Crisis Executive (Exec 2)');
        const rateCardPartTime = partTime ? partTime.price * 1 : 0;
        const rateCardFullTime = fullTime ? fullTime.price * 1 : 0;
        const dailyBuzz = monthBuzz && monthBuzz.volume ? (spam ? computeTimeConstraint(convertToSpamVolume(monthBuzz.volume * 1, spam), newFields.data_freq) : computeTimeConstraint(monthBuzz.volume * 1, newFields.data_freq)) : 0;
        const monitorByLevel = newFields.category ? newFields.category.split('_')[2] * 1 : 0;
        const clarifySpeed = newFields.category ? newFields.category.split('_')[3] * 1 : 0;
        const price = computeDailypriceForCrisis({ dailyBuzz, monitorByLevel, clarifySpeed, rateCardPartTime, rateCardFullTime });
        setPriceForCrisis({
          project: newFields.project,
          freq: newFields.data_freq,
          category: newFields.category ? newFields.category.split('_')[0] : '',
          brand: monthBuzz && monthBuzz.name ? monthBuzz.name : '',
          price: price ? Math.ceil(price) : 0,
          created_by: currentUser,
          updated_by: currentUser,
          created_at: moment().unix(),
          updated_at: moment().unix(),
        });
        setTotalPrice(price);
      }
    } else {
      if (name && Object.keys(dataComp[0]).some(key => dataComp[0][key].next !== 0) && (inputFields.category && inputFields.category !== fields.category)) {
        setFields(newFields);
        setDataComp(INIT_DATA_COMP);
        setDataSource(INIT_DATA_SOURCE);
        setTotalTime(0);
        setTotalPrice(0);
        setChosenBrand(-1);
        setPriceForCrisis({});
        setIsResetDataComp(true);
        resetSampleSize();
        return;
      }
      // const newDataComp = computeDataCompWithSpam(dataComp, spam);
      const newDataComp = dataComp;
      setDataComp(newDataComp);
      if (newFields.data_freq || newFields.category) {
        const newData = [...dataSource];
        const oldDataComp = getOldDataComp(newDataComp);
        if (newFields.data_freq && newDataComp && newDataComp[0] && Object.keys(newDataComp[0]).length > 0 && newFields.data_freq !== fields.data_freq && !isEmptySampleList) {
          const newDataCompByFreq = Object.keys(newDataComp[0]).map(key => computeTimeConstraint(newDataComp[0][key].next, newFields.data_freq));
          fetchMultiSampleSize({ volumes: newDataCompByFreq });
        }
        const mergedDataComp = mergeDataComp(newDataComp, sampleList);
        if (newFields.data_freq) {
          newData.forEach((_, i) => { newData[i].freq = newFields.data_freq });
        }
        const computedData = computeData(newData, newFields, rateCards, mergedDataComp, freq, peopleLevelList, oldDataComp, spamOfCategory);
        setDataSource(computedData.convertedNewData);
        setTotalTime(computedData.totalHour);
        setTotalPrice(computedData.totalPrice);
      }
    }
    setFields(newFields);
    setIsReset(false);
    setIsResetDataComp(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (currentTab === 'crisis') {
      addCrisis({ params: priceForCrisis });
      return;
    }
    const dataCompByFreq = Object.keys(dataComp[0]).map(key => computeTimeConstraint(dataComp[0][key].next, fields.data_freq));
    const finalDataComp = Object.keys(dataComp[0]).map((key, idx) => ({ name: dataComp[0][key].name, isNotExact: dataComp[0][key].isNotExact || 0, comp: dataCompByFreq[idx], sample: sampleList[idx] }));
    const params = dataSource.map(data => ({
      type: currentTab,
      index: data.key * 1 + 1,
      project: fields.project,
      level: fields.category ? fields.category.split('_')[0] : '',
      data_freq: fields.data_freq,
      price: totalPrice ? Math.ceil(totalPrice) : 0,
      total_time: totalTime ? totalTime : 0,
      created_by: currentUser,
      updated_by: currentUser,
      created_at: moment().unix(),
      updated_at: moment().unix(),
      sow: data.sow,
      time: data.time,
      freq: data.freq,
      unit_price: data.unit_price,
      dataComp: finalDataComp,
      brands: Object.keys(INIT_DATA_BRAND[0]).map((key, index) => ({ key: index + 1, value: data[`brand${index + 1}`] && isNaN(data[`brand${index + 1}`] * 1) ? data[`brand${index + 1}`] : data[`brand${index + 1}`] * 1 })),
    }));
    addQuota({ params });
  };

  const handleReset = (e) => {
    e.preventDefault();
    reset();
  };

  const handleChangeTab = (key) => {
    reset();
    setCurrentTab(key);
    if (key === 'campaign' && isEmpty(campaigns)) {
      fetchCampaign();
    }
    if (key === 'campaign' && isEmpty(peopleLevelInCampaigns)) {
      fetchPeopleLevelInCampaign();
    }
  };

  const handleChangeIncludingTracking = (data, index, checked) => {
    // if (!chosenBrand && checked) {
    //   message.warning(`Campaign ${data.name} không có trong Brand tracking!`);
    //   return;
    // }
    const chosenCampaign = campaigns.find(campaign => campaign.campaign === data.name);
    data.prev = chosenCampaign && chosenCampaign.value * (checked ? (100 - savingPercentOfCategory * 1) / 100 : 1);
    data.next = chosenCampaign && chosenCampaign.value * (checked ? (100 - savingPercentOfCategory * 1) / 100 : 1);
    handleSaveComp({[index]: data});
  };

  const handleFetchSampleSize = (key, value) => {
    const foundKey = getKeyFromDataComp(key);
    setChosenBrand(foundKey.key);
    // fetchSampleSize({ volume: value === 1 ? (spamOfCategory ? convertToSpamVolume(dataComp[0][foundKey.name].prev, spamOfCategory) : dataComp[0][foundKey.name].prev) : 0, index: foundKey.key });
    fetchSampleSize({ volume: value === 1 ? computeTimeConstraint(dataComp[0][foundKey.name].prev, fields.data_freq) : 0, index: foundKey.key });
  };

  const handleFetchSampleSizeFromChangingBrand = (data) => {
    const key = Object.keys(data)[0];
    const index = Object.keys(dataComp[0]).findIndex(item => item === key);
    setChosenBrand(index);
    const computedData = computeTimeConstraint(data[key], fields.data_freq);
    fetchSampleSize({ volume: dataSource[0][`brand${index+1}`] && computedData ? computedData.prev : 0, index });
  };

  useEffect(() => {
    reset();
    fetchCategory();
    fetchFreq();
    fetchBuzz();
    fetchRateCard();
    fetchRateCardValue();
    fetchPeopleLevelInBrand();
  }, [fetchBuzz, fetchCategory, fetchFreq, fetchRateCard, fetchRateCardValue, reset, fetchPeopleLevelInBrand]);

  useEffect(() => {
    if (payload.message) {
      if (payload.code === 200) {
        message.success({ content: payload.message, key: 'updatable', duration: 3 });
      } else {
        message.error({ content: payload.message, key: 'updatable', duration: 4 });
      }
      resetAddQuota();
    }
  }, [payload.code, payload.message, resetAddQuota]);

  useEffect(() => {
    if (payloadCrisis.message) {
      if (payloadCrisis.code === 200) {
        message.success({ content: payloadCrisis.message, key: 'updatable', duration: 3 });
      } else {
        message.error({ content: payloadCrisis.message, key: 'updatable', duration: 4 });
      }
      resetAddCrisis();
    }
  }, [payloadCrisis.code, payloadCrisis.message, resetAddCrisis]);

  useEffect(() => {
    if ((!loadingSample || !loadingSampleMulti) && !isEmpty(sampleList) && !isEmpty(dataComp) && !isEmpty(dataSource) && !isEmpty(freq) && !isEmpty(peopleLevelList) && !isEmpty(rateCards)) {
      const oldDataComp = getOldDataComp(dataComp);
      const mergedDataComp = mergeDataComp(dataComp, sampleList);
      const computedData = computeData(dataSource, fields, rateCards, mergedDataComp, freq, peopleLevelList, oldDataComp, spamOfCategory);
      setDataSource(computedData.convertedNewData);
      setTotalTime(computedData.totalHour);
      setTotalPrice(computedData.totalPrice);
    }
  }, [loadingSample, loadingSampleMulti, sampleList]);

  return (
    <>
      <Row>
        <Col span={24}>
          <Widget
            styleName="gx-order-history"
            title={<h2 className="h4 gx-text-capitalize gx-mb-0">Create</h2>}
          >
            <div>
              <Tabs onChange={handleChangeTab} type="card">
                <TabPane tab="BRAND" key="brand">
                  <div style={{ marginTop: 32 }}>
                    <FormInput isReset={isReset} onChangeFields={handleChangeFormFields} loadingCategory={loadingCategory} categories={categories} loadingFreq={loadingFreq} freq={freq} spam={spamOfCategory} />
                  </div>
                  <Table
                    rowKey='brand'
                    className='gx-table-no-bordered'
                    scroll={{ x: 1500 }}
                    pagination={false}
                    bordered={false}
                    size='small'
                    components={componentsBrand}
                    rowClassName={() => 'editable-row'}
                    dataSource={INIT_DATA_BRAND}
                    columns={columnsBrand}
                  />
                </TabPane>
                <TabPane tab="CAMPAIGN" key="campaign">
                  <div style={{ marginTop: 32 }}>
                    <FormInput isReset={isReset} onChangeFields={handleChangeFormFields} loadingCategory={loadingCategory} categories={categories} loadingFreq={loadingFreq} freq={freq} spam={spamOfCategory} />
                  </div>
                  <Table
                    rowKey='brand'
                    className='gx-table-no-bordered'
                    scroll={{ x: 1500 }}
                    pagination={false}
                    bordered={false}
                    size='small'
                    components={componentsCampaign}
                    rowClassName={() => 'editable-row'}
                    dataSource={INIT_DATA_BRAND}
                    columns={columnsCampaign}
                  />
                </TabPane>
                <TabPane tab="CRISIS" key="crisis">
                  <div>
                    <FormInput spam={spamOfCategory} categoryNameChosen={categoryNameChosen} isCrisisForm isReset={isReset} brands={brands} loadingBuzz={loadingBuzz} onChangeFields={handleChangeFormFields} loadingCategory={loadingCategory} categories={categories} loadingFreq={loadingFreq} freq={freq} />
                    <CalculatedCrisis onChangeFields={handleChangeFormFields} isResetDataComp={isResetDataComp} price={totalPrice} freq={freq} loadingFreq={loadingFreq} volume={computeTimeConstraint(convertToSpamVolume(monthVolume.volume * 1, spamOfCategory), fields.data_freq)} />
                  </div>
                </TabPane>
              </Tabs>
            </div>

            {['brand', 'campaign'].includes(currentTab) &&
            <>
              <div style={{ marginTop: 32 }}>
                <div className='gx-text-primary'>* Giá trị tương ứng với {currentTab} đã chọn:</div>
                <Table
                  rowKey={(row, index) => `dataComp_${index}`}
                  className='gx-table-no-bordered'
                  pagination={false}
                  bordered={false}
                  size='small'
                  dataSource={dataComp}
                  columns={BuzzColumns(sampleList, loadingSample, loadingSampleMulti, chosenBrand, fields.data_freq, spamOfCategory)}
                />
              </div>
              {currentTab === 'campaign' && <div style={{ marginTop: 32 }}>
                <div className='gx-text-primary'>* Include tracking brand:</div>
                <Table
                  rowKey={(row, index) => `dataIncludingBrand_${index}`}
                  className='gx-table-no-bordered'
                  pagination={false}
                  bordered={false}
                  size='small'
                  dataSource={INIT_DATA_BRAND}
                  columns={IncludingBrandColumns(handleChangeIncludingTracking, dataComp, isReset)}
                />
              </div>}
              <div style={{ marginTop: 32 }}>
                <Table
                  rowKey={(row) => `${row.time}_${row.sow}`}
                  className='gx-table-no-bordered'
                  scroll={{ x: 1615 }}
                  pagination={false}
                  bordered={false}
                  size='small'
                  components={components}
                  rowClassName={(row) => { return ['4', '5', '11'].includes(row.key) ? 'sample-row' : 'editable-row'}}
                  dataSource={dataSource}
                  columns={columns}
                />
              </div>
              <Divider orientation="right">Tổng cộng</Divider>
              <div style={{ textAlign: 'right' }}>
                <div><b>Time: <span className='gx-text-primary'>{totalTime ? totalTime.toFixed(2) : 0} h</span></b></div>
                <div><b>Unit price: <span className='gx-text-primary'>{totalPrice ? Math.ceil(totalPrice).toLocaleString('us') : 0} đ</span></b></div>
              </div>
              </>
            }
            {toggleBSIMsg && <div className='gx-text-primary gx-text-center'>
              * Need to include BSI's cost in the final quotation
            </div>}
            <div className='save-segment'>
              <Button loading={updating || updatingCrisis} disabled={isDisabledSubmit} onClick={handleSubmit} icon='vertical-align-bottom' size='large' type="primary">
                Save
              </Button>
              <Button disabled={updating || updatingCrisis} onClick={handleReset} icon='undo' size='large'>
                Reset
              </Button>
            </div>
          </Widget>
        </Col>
      </Row>
    </>
  );
}

const mapStateToProps = ({ buzz, campaign, auth, freq, category, rateCard, rateCardValue, quota, crisis, sampleSize, peopleLevelInCampaign, peopleLevelInBrand, analysisLevelGuide }) => {
  const { loading: loadingBuzz, data: buzzList } = buzz;
  const { loading: loadingCampaign, data: campaignList } = campaign;
  const { updating, payload } = quota;
  const { updating: updatingCrisis, payload: payloadCrisis } = crisis;
  const { data: rateCardList = [] } = rateCard;
  const { data: rateCardValueList = [] } = rateCardValue;
  const { currentUser } = auth;
  const { data: categoryList = [], loading: loadingCategory } = category;
  const { data: freqList = [], loading: loadingFreq } = freq;
  const { data: sampleList, loading: loadingSample, loadingMulti: loadingSampleMulti } = sampleSize;
  const { data: peopleLevelInBrandList, loading: loadingPeopleLevelInBrand } = peopleLevelInBrand;
  const { data: peopleLevelInCampaignList, loading: loadingPeopleLevelInCampaign } = peopleLevelInCampaign;

  return { loadingFreq, loadingCampaign, loadingSampleMulti, buzzList, campaignList, currentUser, categoryList, freqList, sampleList, peopleLevelInBrandList, peopleLevelInCampaignList, loadingPeopleLevelInBrand, loadingPeopleLevelInCampaign, loadingCategory, loadingBuzz, loadingSample, rateCardList, rateCardValueList, updating, updatingCrisis, payload, payloadCrisis };
};

export default connect(
  mapStateToProps,
  { fetchCategory, fetchFreq, fetchBuzz, fetchCampaign, fetchRateCard, fetchRateCardValue, fetchSampleSize, fetchMultiSampleSize, fetchPeopleLevelInCampaign, fetchPeopleLevelInBrand, addQuota, addCrisis, resetAddQuota, resetAddCrisis, resetSampleSize, updateSampleSize }
)(InsertQuota);
